import StSystemNavigationDrawer from '@/language/es/StSystemNavigationDrawer';
import StCompanySelection from '@/language/es/StCompanySelection';
import LoginView from '@/language/es/LoginView';
import ErrorStatus from '@/language/es/ErrorStatus';
import DataManagement from '@/language/es/DataManagement';
import views from '@/language/es/views';
import components from '@/language/es/components';
import mixins from '@/language/es/mixins';
import BrandHealth from '@/language/es/BrandHealth';
import stocks from '@/language/es/stocks';
import DistributionMediaPieChart from '@/language/es/DistributionMediaPieChart';
import library from '@/language/es/library';
import utils from '@/language/es/utils';

export default {
  systemName: 'Dash',
  StSystemNavigationDrawer,
  StCompanySelection,
  LoginView,
  ErrorStatus,
  DataManagement,
  views,
  components,
  mixins,
  BrandHealth,
  stocks,
  DistributionMediaPieChart,
  library,
  utils,
};
